import React from 'react'
import '../assets/css/PrivacyPolicy.css'

export default function KidsAdvertisingPolicy() {
  return (
    <div className='bg-container'>
      <div className="privacy-container">

        <h1 className="privacy-title">Kids Advertising Policy</h1>
        <p id='effective-date'><strong>Effective Date:</strong> 8 December 2025</p>

        <h2 className="section-title">1. Overview</h2>
        <p>
          <strong>Learnberry</strong> is a children’s educational app listed in the
          Kids Category on the Apple App Store. To support app development, we display
          limited third-party contextual advertisements. We are committed to ensuring a
          safe and age-appropriate experience for children.
        </p>

        <h2 className="section-title">2. Type of Advertising</h2>
        <p>
          We only display <strong>non-personalized, contextual ads</strong>. These ads
          are shown based solely on general app content and not on user behavior.
        </p>

        <p>We <strong>do NOT</strong>:</p>
        <ul>
          <li>Show personalized or interest-based ads</li>
          <li>Track user behavior for advertising purposes</li>
          <li>Create advertising profiles of children</li>
          <li>Use remarketing or retargeting</li>
          <li>Collect personal data for advertising</li>
        </ul>

        <h2 className="section-title">3. Advertising Partner</h2>
        <p>We use:</p>
        <ul>
          <li><strong>Google AdMob (Google LLC)</strong></li>
        </ul>

        <p>We configure AdMob to comply with:</p>
        <ul>
          <li>COPPA (Children’s Online Privacy Protection Act)</li>
          <li>GDPR-Kids (where applicable)</li>
          <li>Apple’s Kids Category guidelines</li>
        </ul>

        <p>All ads are served using:</p>
        <ul>
          <li><strong>nonPersonalizedAds = true</strong></li>
          <li><strong>child-directed treatment enabled</strong></li>
          <li><strong>G-rated content filtering</strong></li>
        </ul>

        <h2 className="section-title">4. Data Used for Advertising</h2>
        <p>We do <strong>not</strong> collect or share:</p>
        <ul>
          <li>Names or contact information</li>
          <li>Email addresses</li>
          <li>Photos, videos, or audio recordings</li>
          <li>Precise (GPS) location</li>
          <li>Sensitive personal information</li>
        </ul>

        <p>AdMob may receive limited, <strong>non-personal technical data</strong> such as:</p>
        <ul>
          <li>Approximate device type</li>
          <li>Basic identifiers for fraud prevention</li>
          <li>General app usage information</li>
        </ul>

        <p>This information is <strong>never used to personalize ads</strong>.</p>

        <h2 className="section-title">5. Human Review of Ad Creatives</h2>
        <p>To ensure all displayed ads are appropriate for children, we:</p>
        <ul>
          <li>Enable child-directed mode in our ad network settings</li>
          <li>Manually review and restrict allowed ad categories</li>
          <li>
            Block inappropriate content such as violence, gambling, dating, drugs,
            alcohol, and adult material
          </li>
          <li>Review ads when configuration changes are made</li>
          <li>Investigate and block inappropriate ads reported by parents</li>
        </ul>

        <h2 className="section-title">6. Reporting Inappropriate Ads</h2>
        <p>If you see an advertisement that is not suitable for children, please contact us:</p>

        <p style={{ margin: 0 }}>
          <strong>Email:</strong>
          <a id='mail-url'
             href='mailto:info@windzoon.com'
             target='_blank'
             rel="noreferrer"> info@windzoon.com</a>
        </p>

        <p>
          If possible, please attach a screenshot and the approximate time it appeared.
          We review all reports and block inappropriate advertisers or categories.
        </p>

        <h2 className="section-title">7. Changes to This Policy</h2>
        <p>
          We may update this Kids Advertising Policy occasionally. The latest version
          will reflect the updated “Effective Date.”
        </p>

        <h2 className="section-title">8. Contact Us</h2>
        <p style={{ margin: 0 }}>
          <strong>Email:</strong>
          <a id='mail-url'
             href='mailto:info@windzoon.com'
             target='_blank'
             rel="noreferrer"> info@windzoon.com</a>
        </p>
        <p>
          <strong>Website:</strong>
          <a id='web-url'
             href='https://www.windzoon.com/'
             target='_blank'
             rel="noreferrer"> www.windzoon.com</a>
        </p>

      </div>
    </div>
  )
}
